import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const HEART_FORM_INITIAL_VALUES = {
  sections: {
    heart: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamHeartSections = keyof typeof HEART_FORM_INITIAL_VALUES.sections;
